(() => {
  const HERO_VIDEO_SELECTOR = '.slideshow-slider-container .slideshow-background-video';

  const isVisibleActiveVideo = (video) => {
    const slide = video.closest('.swiper-slide');
    if (slide && !slide.classList.contains('swiper-slide-active') && !slide.classList.contains('is-single-slide')) {
      return false;
    }

    return getComputedStyle(video).display !== 'none' && video.getClientRects().length > 0;
  };

  const playHeroVideos = () => {
    if (document.visibilityState === 'hidden') return;

    document.querySelectorAll(HERO_VIDEO_SELECTOR).forEach((video) => {
      if (!isVisibleActiveVideo(video)) return;

      // Browsers can restore the homepage from the back-forward cache with a
      // muted video paused, even though its autoplay attribute is still set.
      video.muted = true;
      video.defaultMuted = true;
      video.playsInline = true;
      video.autoplay = true;
      video.play().catch(() => {});
    });
  };

  const queueHeroVideoPlayback = () => {
    requestAnimationFrame(() => {
      playHeroVideos();
      window.setTimeout(playHeroVideos, 150);
    });
  };

  document.addEventListener('DOMContentLoaded', queueHeroVideoPlayback, { once: true });
  window.addEventListener('pageshow', queueHeroVideoPlayback);
  window.addEventListener('focus', queueHeroVideoPlayback);
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') queueHeroVideoPlayback();
  });
})();
